import getFreshSideObject from "./getFreshSideObject.js";
export default function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/mergePaddingObject.js
// module id = ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
// module chunks = 1